// extracted by mini-css-extract-plugin
export default {"zoomModal":"R2-z"};